export const notificationKeys = {
  all: ['notifications'] as const,
  unreadCount: () => ['notifications', 'unreadCount'] as const,
  lists: () => ['notifications', 'list'] as const,
  list: (unreadOnly: boolean) => ['notifications', 'list', { unreadOnly }] as const,
};
